import _ from 'lodash';

export const isMockingUser = (user) => !!_.get(user, 'realProfile');
export const getUserObject = (user) => _.get(user, 'profile', user);
export const getAccessToken = (user) => _.get(user, 'tokens.access_token');
export const getEmail = (user) => _.get(getUserObject(user), 'email');
export const getFirstName = (user) => _.get(getUserObject(user), 'first_name');
export const getLastName = (user) => _.get(getUserObject(user), 'last_name');
export const getFullName = (user) => `${getFirstName(user)} ${getLastName(user)}`;
export const getUserId = (user) => _.get(getUserObject(user), 'id') || _.get(getUserObject(user), 'pk'); // pk old concept, remove after Jan 3, 2022
export const isLoggedIn = (user) => user && !!getEmail(getUserObject(user));
export const hasZoomConnected = (user) => _.get(getUserObject(user), 'zoom_connected');
export const hasHubspotConnected = (user) => _.get(getUserObject(user), 'hubspot_connected');
export const isSuperUser = (user) => _.get(getUserObject(user), 'is_superuser');
export const isCompanyAdmin = (user) => _.get(getUserObject(user), 'is_company_admin');
